import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import s from './AIChatPlaygroundSettingsTab.scss';
import { aIChatPlaygroundContext } from '../../aIChatPlaygroundConstants';
import { AIChatPlaygroundStore } from '../../AIChatPlaygroundStore';
import { useContainerData } from '../../../../shared/public/SlHooks/useContainerData';
import { AIChatPlaygroundSetting } from './AIChatPlaygroundSetting/AIChatPlaygroundSetting';
import { AIChatPlaygroundSettingInfo } from './AIChatPlaygroundSettingInfo/AIChatPlaygroundSettingInfo';
import { Container } from '../../../../symphony';

export const AIChatPlaygroundSettingsTab = () => {
	useStyles(s);
	const aiChatSettings = Container.take('global', 'ai-chat-settings');
	const { configs, modelConfigs } = useContainerData(
		aIChatPlaygroundContext.value,
		AIChatPlaygroundStore,
		['configs', 'modelConfigs'],
	);

	return (
		<div className="ai-chat-playground-settings-tab">
			{
				configs?.settingsInstructions
				&& (
					<div className="ai-chat-playground-settings-tab__instructions" dangerouslySetInnerHTML={{ __html: configs.settingsInstructions }} />
				)
			}
			<div className="ai-chat-playground-settings-tab__options">
				{
					!!aiChatSettings && modelConfigs.map((setting) => (
						<AIChatPlaygroundSetting key={setting.key} setting={setting} />
					))
				}
			</div>
			<AIChatPlaygroundSettingInfo />
		</div>
	);
};
